import { z } from 'zod';

const PaymentNodeMetaModel = z.object({
  position: z.object({ x: z.number(), y: z.number() }),
  nodeId: z.string().uuid(),
});

export const PaymentNodesMetaModel = PaymentNodeMetaModel.array();

const _PaymentNodeMetaFormSchema = PaymentNodeMetaModel.pick({
  position: true,
  nodeId: true,
});
